import { useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import Entities from 'STORE';

export function useOfflineStatusHandlerPresenter(): void {
  const presenter = useLocalStore(() => ({
    startOnline(): void {
      Entities.App.setOfflineNetworkStatus(false);
    },
    startOffline(): void {
      Entities.App.setOfflineNetworkStatus(true);
    },
  }));

  useEffect(() => {
    window.addEventListener('online', presenter.startOnline);
    window.addEventListener('offline', presenter.startOffline);

    return () => {
      window.removeEventListener('online', presenter.startOnline);
      window.removeEventListener('offline', presenter.startOffline);
    };
  }, []);
}
